import React from 'react';

import { useGetPendingRequestsQuery } from 'features/recording';
import ErrorLayout from 'components/ErrorLayout';
import GlobalLoader from 'components/GlobalLoader';
import Loader from 'components/Loader';
import RecordingRequestRow from '../RecordingRequestRow';
import RecordingRequestModal from '../RecordingRequestModal';
import Table from 'components/Table';
import TableBody from 'components/TableBody';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

export default function RecordingRequestTable() {
  const { isLoading, isFetching, error, data, refetch } =
    useGetPendingRequestsQuery();

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load pending recording requests"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data?.length > 0) {
    const { data: pendingRequests } = data || {};
    return (
      <>
        <GlobalLoader isVisible={isFetching} />
        <RecordingRequestModal />
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Mentee Details</TableCell>
              <TableCell>Request Reason</TableCell>
              <TableCell>Requested On</TableCell>
              <TableCell>Documents</TableCell>
              <TableCell>Module Details</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pendingRequests.map((request) => (
              <RecordingRequestRow
                recordingRequest={request}
                key={request.id}
              />
            ))}
          </TableBody>
        </Table>
      </>
    );
  } else {
    return (
      <>
        <ErrorLayout
          title="No Pending Request"
          message="No request is in pending state currently."
        />
      </>
    );
  }
}
